import React from "react";
import "./index.scss";
import StoreButtons from "../../components/Referral/StoreButtons";

interface Props {
  onContinue: () => void;
}

const MobileLanding: React.FC<Props> = ({ onContinue }) => {
  return (
    <div className="mobile-landing">
      <div className="mobile-landing__content">
        <img
          src="/images/logo-icon.svg"
          alt="Beam Live"
          className="mobile-landing__logo"
        />

        <h1 className="mobile-landing__title">Get the best experience</h1>
        <p className="mobile-landing__subtitle">
          Download the Beam Live app for the full experience, or continue in
          your browser.
        </p>

        <StoreButtons variant="beamlive" />

        <button
          type="button"
          className="mobile-landing__continue"
          onClick={onContinue}
        >
          Continue on browser
        </button>
      </div>
    </div>
  );
};

export default MobileLanding;
